import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import StripeCheckout from "react-stripe-checkout";
import Swal from "sweetalert2";
import BaseUrl from "../../BaseUrl";

const Payment = () => {
  window.sessionStorage.setItem("prevPath", window.location.pathname);
  const { id, email, userid } = useParams();
  window.sessionStorage.setItem("previd", id);
  window.sessionStorage.setItem("prevemail", email);
  window.sessionStorage.setItem("prevuserid", userid);
  const [loader, setLoader] = useState(false);
  const history = useHistory();
  const stripeRef = useRef();
  useEffect(() => {
    stripeRef.current.click();
  }, []);
  const onToken = (token) => {
    var formdata = new FormData();
    formdata.append("plan", id);
    formdata.append("source", token?.id);
    formdata.append("token[billing_details][name]", email);
    formdata.append("user_id", userid);
    setLoader(true);
    var config = {
      method: "post",
      url: `${BaseUrl.baseurl}/subscription`,
      data: formdata,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token.token}`,
      },
    };

    axios(config)
      .then(function (response) {
        if (response?.data?.status === true) {
          localStorage.clear();
          setLoader(false);
          Swal.fire({
            showCloseButton: true,
            toast: true,
            icon: "success",
            title: response?.data?.message,
            animation: true,
            position: "top-right",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });
          window.scrollTo({
            top: 100000 * 100000,
            behavior: "smooth",
          });
        } else {
          setLoader(false);
        }
        if (!localStorage.getItem("userDetails")) {
          history.push("/");
        } else {
          history.push("/");
        }
      })
      .catch(function (error) {
        console.log(error);
        setLoader(false);

        // setFielderr(error?.response?.data?.errors);
        Swal.fire({
          showCloseButton: true,
          toast: true,
          icon: "error",
          title: error?.response?.data?.message,
          animation: true,
          position: "top-right",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", Swal.stopTimer);
            toast.addEventListener("mouseleave", Swal.resumeTimer);
          },
        });
      });
  };
  useEffect(() => {}, []);
  const loginbg = require("../../images/paise.gif");
  return (
    <>
      {loader ? <div className="loader"></div> : null}
      <div className="container">
        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-8">
            <img
              src={loginbg}
              alt="no Img"
              // width={window.screen.width}
              // height={window.screen.height}
            />
          </div>
          <div className="col-md-2"></div>
        </div>
      </div>

      <StripeCheckout
        token={onToken}
        stripeKey="pk_test_51MdqNVAOm2Y7pmXtOPM7GnEqm0icL0bkvRAKxCdVUjnRyIKkDh5HGnVexJGiDG48c9B4kLQKxIVwCCC4DyTjdP0o00FWouzEvv"
        name={email}
      >
        <button ref={stripeRef} style={{ display: "none" }}>
          buy
        </button>
      </StripeCheckout>
    </>
  );
};

export default Payment;
